export const COMPLAIN_TYPE = {
    1: '数量',
    2: '品质',
    3: '品种',
    4: '其他'
};

export const COMPLAIN_RESULT_COMPENSATE = "有责，赔付";
export const COMPLAIN_RESULT_NO_COMPENSATE = "无责，无需赔付";